<div [bas-tooltip]="hint"
	 [class.tiny]="tiny"
	 [class.newicon]="newicon">
	<bas-tooltip-content>
		<ng-content></ng-content>
	</bas-tooltip-content>
</div>